<template>
    <div :class="`packages_${index}_input main_div`">
        <div :class="`options-navig-block shipment_dimensions_block` + (isEdit ? ' mb-2 row-4 ' : '')">
            <div class="value-column" :class="{ 'column-4': isEdit, 'option-line-column-19': !isEdit }">
                <span v-if="!isEdit" class="counter">{{ index + 1 }}.&nbsp;</span>
                <label :class="{ 'size-16': isEdit }">{{ $helper.trans('Weight_kg') }}</label>
                <div class="value-wrap" :class="`packages_${index}__input packages_${index}_weight_input`">
                    <button tabindex="-1" type="button" @click="iterateValue('weight', -0.1, 1)" class="btn-down"></button>
                    <input type="number" @input="validateDimensions()" class="weight" v-model="$store.state.packagesDimensions[index].weight" />
                    <button tabindex="-1" type="button" @click="iterateValue('weight', 0.1, 1)" class="btn-up"></button>
                </div>
            </div>
            <div class="value-column" :class="{ 'column-4': isEdit, 'option-line-column-19': !isEdit }" v-show="$store.state.packageType == '02'">
                <label :class="{ 'size-16': isEdit }">{{ $helper.trans('Length_cm') }}</label>
                <div class="value-wrap" :class="`packages_${index}_length_input`">
                    <button tabindex="-1" type="button" @click="iterateValue('length', -1)" class="btn-down"></button>
                    <input type="number" @input="validateDimensions()" v-model="$store.state.packagesDimensions[index].length" />
                    <button tabindex="-1" type="button" @click="iterateValue('length', 1)" class="btn-up"></button>
                </div>
            </div>
            <div class="value-column" :class="{ 'column-4': isEdit, 'option-line-column-19': !isEdit }" v-show="$store.state.packageType == '02'">
                <label :class="{ 'size-16': isEdit }">{{ $helper.trans('Width_cm') }}</label>
                <div class="value-wrap" :class="`packages_${index}_width_input`">
                    <button tabindex="-1" type="button" @click="iterateValue('width', -1)" class="btn-down"></button>
                    <input type="number" @input="validateDimensions()" v-model="$store.state.packagesDimensions[index].width" />
                    <button tabindex="-1" type="button" @click="iterateValue('width', 1)" class="btn-up"></button>
                </div>
            </div>
            <div class="value-column" :class="{ 'column-4': isEdit, 'option-line-column-19': !isEdit }" v-show="$store.state.packageType == '02'">
                <label :class="{ 'size-16': isEdit }">{{ $helper.trans('Height_cm') }}</label>
                <div class="value-wrap" :class="`packages_${index}_height_input`">
                    <button tabindex="-1" type="button" @click="iterateValue('height', -1)" class="btn-down"></button>
                    <input type="number" @input="validateDimensions()" v-model="$store.state.packagesDimensions[index].height" />
                    <button tabindex="-1" type="button" @click="iterateValue('height', 1)" class="btn-up"></button>
                </div>
            </div>
            <div class="value-column last-value" :class="{ 'option-line-column-19': !isEdit }" v-show="$store.state.packageType == '02'">
                <button tabindex="-1" type="button" @click="addPackageDimensionsRow()" class="btn-add"></button>
                <button tabindex="-1" v-if="$store.state.packagesDimensions.length > 1" type="button" @click="removePackageDimensionsRow(index)" class="btn-remove"></button>
                <button tabindex="-1" type="button" @click="copyPackageDimensionsRow(index)" class="btn-copy"></button>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function () {
        return {
            previousDimensions: undefined,
            dimensionsTimer: null,
        }
    },
    props: {
        index: {
            type: Number,
            required: true,
        },
        isEdit: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            },
        }
    },
    created: function () {
        let vueThis = this;

        vueThis.previousDimensions = structuredClone(vueThis.$store.state.packagesDimensions);

        $.each(vueThis.$store.state.packagesDimensions, function (index, element) {
            vueThis.$store.state.packagesDimensions[index] = {
                weight: parseFloat(element.weight),
                length: parseFloat(element.length),
                width: parseFloat(element.width),
                height: parseFloat(element.height),
                insurance: element.insurance,
            };
        });
    },
    methods: {
        validateDimensions() {     
            let vueThis = this;  
            vueThis.$store.state.checkOutSteps.first = false;      
            vueThis.$store.state.awaitingActions.resetShippings = true;
            vueThis.$forceUpdate();

            $.each(vueThis.$store.state.packagesDimensions, function (index, element) {
                vueThis.$store.state.packagesDimensions[index]['weight'] = parseFloat(element.weight);
                vueThis.$store.state.packagesDimensions[index]['length'] = parseFloat(element.length);
                vueThis.$store.state.packagesDimensions[index]['width'] = parseFloat(element.width);
                vueThis.$store.state.packagesDimensions[index]['height'] = parseFloat(element.height);
            });

            if (vueThis.dimensionsTimer) {
                clearTimeout(vueThis.dimensionsTimer);
            }

            vueThis.dimensionsTimer = setTimeout(() => {
                vueThis.$helper.validate(['packages'], {
                    packageType: vueThis.$store.state.packageType,
                    packages: vueThis.$store.state.packagesDimensions,
                });
            }, 1000);
        },
        iterateValue: function (dimension, amount, digits = 0) {
            if (this.$store.state.packagesDimensions[this.index][dimension] <= 0 && amount < 0) {
                return;
            }
            let oldAmount = parseFloat(this.$store.state.packagesDimensions[this.index][dimension]);
            let newAmount = (oldAmount + amount).toFixed(digits);
            this.$store.state.packagesDimensions[this.index][dimension] = newAmount;
            this.$forceUpdate();
            this.validateDimensions();
        },
        addPackageDimensionsRow: function () {
            if (this.$store.state.selectedShippingType === 'import' && this.$store.state.packagesDimensions.length >= 20) {
                $('.maximum-packets-warning').show();
                setTimeout(() => {
                    $('.maximum-packets-warning').fadeOut('slow');
                }, 2000);
                return;
            }

            this.$store.state.packagesDimensions.push({
                weight: 1,
                length: 1,
                width: 1,
                height: 1,
                insurance: '',
            });
            this.$store.state.awaitingActions.resetShippings = true;
        },
        removePackageDimensionsRow: function (index) {
            this.$store.state.packagesDimensions.splice(index, 1);
            this.$store.state.awaitingActions.resetShippings = true;
            if (this.$store.state.selectedShippingType === 'import' && this.$store.state.packagesDimensions.length < 20) {
                $('.maximum-packets-warning').hide();            
                return;
            }
        },
        copyPackageDimensionsRow: function (index) {
            if (this.$store.state.selectedShippingType === 'import' && this.$store.state.packagesDimensions.length >= 20) {
                $('.maximum-packets-warning').show();
                setTimeout(() => {
                    $('.maximum-packets-warning').fadeOut('slow');
                }, 2000);
                return;
            }

            this.$store.state.packagesDimensions.push({
                weight: this.$store.state.packagesDimensions[index].weight,
                length: this.$store.state.packagesDimensions[index].length,
                width: this.$store.state.packagesDimensions[index].width,
                height: this.$store.state.packagesDimensions[index].height,
                insurance: '',
            });
            this.$store.state.awaitingActions.resetShippings = true;
        },
    },
    watch: {
        '$store.state.packageType': function () {
            if (this.$store.state.packageType === '01' || this.$store.state.packageType === '04') {
                this.$store.state.packagesDimensions = [this.$store.state.packagesDimensions[0]];
            }
            this.$store.state.checkOutSteps.first = false;  
        },
    }
};
</script>
